export const WHATSAPP_DISPLAY = "+55 49 99748-414";
export const INSTAGRAM_HANDLE = "@edalix_tecnologia";
export const INSTAGRAM_URL = "https://instagram.com/edalix_tecnologia";
export const SITE_URL = "https://edalix.com.br";
export const SITE_DOMAIN = "edalix.com.br";

export const waLink = (msg) =>
  `https://wa.me/554999748414?text=${encodeURIComponent(msg)}`;

export const WA_ORCAMENTO = waLink(
  "Olá! Quero solicitar um orçamento com a EDALIX."
);
export const WA_ESPECIALISTA = waLink(
  "Olá! Quero falar com um especialista da EDALIX."
);
export const WA_CTA = waLink(
  "Olá! Tenho uma ideia e quero transformá-la em uma solução digital com a EDALIX."
);
export const WA_PROJETOS = waLink(
  "Olá! Quero conhecer mais projetos e demonstrações da EDALIX."
);
export const waProjeto = (nome) =>
  waLink(
    `Olá! Vi a demonstração "${nome}" no site da EDALIX e quero algo parecido para o meu negócio.`
  );
export const waSolucao = (solucao) =>
  waLink(`Olá! Quero saber mais sobre ${solucao} desenvolvidos pela EDALIX.`);

export const NAV = [
  { id: "inicio", label: "Início" },
  { id: "solucoes", label: "Serviços" },
  { id: "projetos", label: "Projetos" },
  { id: "sobre", label: "Sobre" },
  { id: "contato", label: "Contato" },
];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.3 });
  } else {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};
